import styled from "styled-components";
import { Box } from "grid-styled";

// Here we create a component that will rotate everything we pass in over two seconds
const Rotate = styled(Box)`
    transform: ${props => props.transform};
    transition: transform 0.2s ease;
    transform-origin: center;
    line-height: 1;
`;

export default Rotate;



// WEBPACK FOOTER //
// ./src/components/Rotate/index.js